import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralMyCoach = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.background.light};

  .MuiTabs-scroller.MuiTabs-fixed {
    margin-left: 1.5rem;
  }
  .MuiPaper-root {
    background-color: ${({ theme }) => theme.background.light};
  }
`;

export const ContentFilters = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;
